"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showHeader ? _c('div', {
    staticClass: "app-header app-theme-bg",
    on: {
      "click": _vm.onHeaderClick
    }
  }, [_vm.isChannel() ? [_c('div', {
    staticClass: "app-header-center"
  }), !_vm.isJoined && _vm.isConnected ? _c('div', {
    staticClass: "app-header-notjoined"
  }, [_c('a', {
    staticClass: "u-link app-header-join-channel-button",
    on: {
      "click": _vm.joinCurrentBuffer
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('container_join')) + " ")])]) : _vm._e()] : _vm.isServer() ? [_c('div', {
    staticClass: "app-header-center"
  }), _c('div', {
    staticClass: "app-header-server-connection"
  }, [_vm.buffer.getNetwork().state === 'disconnected' ? _c('a', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": _vm.onConnectButtonClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('connect')) + " ")]) : _vm.buffer.getNetwork().state === 'connecting' ? _c('span', [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('connecting')) + " ")]) : _vm._e()])] : _vm.isQuery() ? [_vm.previousChannelBuffer ? _c('a', {
    staticClass: "app-header-back",
    attrs: {
      "title": `Retour à ${_vm.previousChannelBuffer.name}`
    },
    on: {
      "click": function ($event) {
        return _vm.goBackToPrevious();
      }
    }
  }, [_vm._v("←")]) : _vm._e(), _c('div', {
    staticClass: "app-header-center"
  }), _c('div', {
    key: _vm.buffer.id,
    staticClass: "app-header-options"
  }, [_vm.userOnline ? _c('div', {
    staticClass: "app-header-option app-header-option-user",
    class: {
      'app-header-option--active': _vm.sidebarSection === 'user'
    }
  }, [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.toggleUser();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._l(_vm.pluginUiQueryElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      staticClass: "app-header-option",
      attrs: {
        "plugin-props": {
          buffer: _vm.buffer,
          containerheader: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  })], 2)] : _vm.isSpecial() ? [_c('div', {
    staticClass: "app-header-center"
  }), _c('div', {
    staticClass: "app-header-options"
  })] : _vm._e()], 2) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [];